<template>
    <v-card>
        <!-- Toolbar -->
        <v-toolbar
            dark
            color="primary"
        >
            <v-btn
                icon
                dark
                @click="$emit('update:show', false)"
                :disabled="isSaving"
            >
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>
                {{ title }}
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items
                v-if="$vuetify.breakpoint.smAndDown"
            >
                <!-- Delete Option -->
                <v-btn
                    v-if="hasDelete"
                    icon
                    @click="showDeleteDialog = true"
                >
                    <v-icon>
                        delete
                    </v-icon>
                </v-btn>
                <v-divider
                    vertical
                    inset
                />
                <!-- Save Button -->
                <v-btn
                    dark
                    text
                    :loading="isSaving"
                    :disabled="isSaving"
                    @click="onSubmit"
                >
                    Save
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <!-- Form -->
        <v-card-text>
            <v-form
                class="my-3"
                ref="form"
                @submit.prevent="onSubmit"
            >
                <v-autocomplete
                    label="Account"
                    :items="socialIcons"
                    v-model="type"
                    item-value="icon"
                    item-text="text"
                    :rules="[
                        rules.required
                    ]"
                    validate-on-blur
                    color="secondary"
                >
                    <template v-slot:selection="data">
                        <icon-base
                            :icon-name="data.item.icon"
                            class="link-icon"
                        />
                        {{ data.item.text }}
                    </template>
                    <template v-slot:item="data">
                        <icon-base
                            :icon-name="data.item.icon"
                            class="link-icon"
                        />
                        {{ data.item.text }}
                    </template>
                </v-autocomplete>

                <v-text-field
                    label="Text to Display"
                    v-model="text"
                    :rules="[
                        rules.required
                    ]"
                    validate-on-blur
                    color="secondary"
                />

                <v-text-field
                    label="URL"
                    v-model="url"
                    :rules="[
                        rules.required
                    ]"
                    validate-on-blur
                    color="secondary"
                >
                    <!-- currently unused -->
                    <!-- <template v-slot:prepend v-if="$vuetify.breakpoint.smAndUp">
                        {{ linkPrepend }}
                    </template> -->
                </v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions
            v-if="$vuetify.breakpoint.mdAndUp"
        >
            <v-btn
                v-if="hasDelete"
                text
                @click="showDeleteDialog = true"
            >
                <v-icon left>
                    delete
                </v-icon>
                Delete
            </v-btn>
            <v-spacer />
            <v-btn
                text
                @click="$emit('update:show', false)"
            >
                Cancel
            </v-btn>
            <v-btn
                @click="onSubmit"
                color="primary"
                :loading="isSaving"
                :disabled="isSaving"
            >
                Save
            </v-btn>
        </v-card-actions>
        <!-- Delete Dialog -->
        <v-dialog
            v-model="showDeleteDialog"
            max-width="400px"
        >
            <v-card>
                <v-card-title>
                    Delete confirmation
                </v-card-title>
                <v-card-text>
                    Are you sure you want to delete this link?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="showDeleteDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="onDeleteConfirm"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { requiredValidation } from '../../utils/validations'
import MessageBus from '../../utils/buses/MessageBus'
import { default422Error } from '../../utils/constants/errors'
import { IconList } from '../../utils/iconList'
import IconBase from '../../components/IconBase'

export default {
    components: {
        IconBase
    },
    data () {
        return {
            type: null,
            text: null,
            url: null,
            rules: {
                required: requiredValidation
            },
            showDeleteDialog: false,
            socialIcons: IconList
        }
    },

    props: {
        title: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        link: {
            type: Object,
            default: () => ({
                type: null,
                text: null,
                url: null
            })
        },
        isSaving: {
            type: Boolean,
            default: false
        },
        hasDelete: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        // currently unused
        // linkPrepend: function () {
        //     if (this.type && IconMap.hasOwnProperty(this.type)) {
        //         return IconMap[this.type].link
        //     } else {
        //         return ''
        //     }
        // }
        // currently unused
        // urlHint: function () {
        //     if (this.type && IconMap.hasOwnProperty(this.type)) {
        //         return `Enter the remaining url of your ${IconMap[this.type].text} account.`
        //     } else if (this.type && this.type === 'custom') {
        //         // TODO - allow user to select http or https
        //         return 'Enter the full url of your link'
        //     } else {
        //         return 'Choose an account'
        //     }
        // },
        // currently unused
        // urlLabel: function () {
        //     if (this.$vuetify.breakpoint.xsOnly) {
        //         // if link prepend exists use, else return default
        //         if (this.type && IconMap.hasOwnProperty(this.type)) {
        //             return IconMap[this.type].link
        //         } else {
        //             return 'URL'
        //         }
        //     } else {
        //         return 'URL'
        //     }
        // }
    },

    watch: {
        link: {
            immediate: true,
            handler: function (val) {
                this.type = val.type || null
                this.text = val.text || null
                this.url = val.url || null

                // currently disabled
                // remove prepend from url
                // if (
                //     val.type
                //     && IconMap.hasOwnProperty(val.type)
                //     && IconMap[val.type].link
                // ) {
                //     this.url = this.url.replace(IconMap[val.type].link, '')
                // }

                // reset form validations
                if (this.$refs.form) {
                    this.$refs.form.resetValidation()
                }
            }
        }
    },

    methods: {
        onSubmit () {
            if (!this.$refs.form.validate()) {
                MessageBus.sendMessage(default422Error, 'error')
                return
            }

            // currently unused
            // let url
            // if (this.type && IconMap.hasOwnProperty(this.type)) {
            //     url = IconMap[this.type].link + this.url
            // } else {
            //     // custom url
            // }
            if (!this.url.match(/^[a-zA-Z]+:\/\//)) {
                this.url = 'https://' + this.url
            }

            this.$emit('submit', {
                type: this.type,
                text: this.text,
                url: this.url
            })
        },
        onDeleteConfirm () {
            this.$emit('delete', true)
            this.showDeleteDialog = false
        }
    }
}
</script>

<style scoped lang="scss">
.link-icon {
    margin-right: 16px;
}
</style>
